import { render } from "./InspeccionVehicular.vue?vue&type=template&id=0cb91c6a&scoped=true"
import script from "./InspeccionVehicular.vue?vue&type=script&lang=js"
export * from "./InspeccionVehicular.vue?vue&type=script&lang=js"

import "./InspeccionVehicular.vue?vue&type=style&index=0&id=0cb91c6a&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb91c6a"]])

export default __exports__